import { Clear, Check } from '@mui/icons-material';
import { Box, Fab } from '@mui/material';

export default function TargetAttributesSaveButton({
  modifyAttributes,
  refresh,
}: {
  modifyAttributes: () => Promise<void>;
  refresh: () => void;
}) {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 80,
        right: 16,
        zIndex: 1200,
      }}
    >
      <Fab
        onClick={refresh}
        sx={{
          boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.3)',
          color: 'var(--mui-palette-secondary-main)',
          bgcolor: 'white',
          border: '2px solid var(--mui-palette-secondary-main)',
          mr: '10px',
        }}
      >
        <Clear />
      </Fab>
      <Fab
        onClick={modifyAttributes}
        sx={{
          boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.3)',
          border: '2px solid white',
          color: 'white',
        }}
        color="secondary"
      >
        <Check />
      </Fab>
    </Box>
  );
}
